import { render, staticRenderFns } from "./MainSubCurrency.vue?vue&type=template&id=0f844d2d&"
import script from "./MainSubCurrency.vue?vue&type=script&lang=ts&"
export * from "./MainSubCurrency.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports